// extracted by mini-css-extract-plugin
export default {"container":"faq-page_container__2nKGw","title":"faq-page_title__xaC+F","list":"faq-page_list__So4ZL","accordion":"faq-page_accordion__t67M9","input":"faq-page_input__kgBU9"};